import React, { useState } from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./QuestionInput.module.scss";

const QuestionInput = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Short Answer text",
  error,
  required = false,
  type = "text",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const onBlur = () => {
    setIsFocused(false);
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  return (
    <div className={cs(classes.container, { [classes.error]: error })}>
      <label htmlFor={id} className={cs(classes.label)}>
        {label}
        {required && <span className={cs(classes.required)}> *</span>}
      </label>
      <div className={cs(classes.inputWrapper)}>
        <input
          id={id}
          type={type}
          className={cs(classes.input, {
            [classes.focused]: isFocused,
          })}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
        />
        <div className={cs(classes.underline)} />
      </div>
      {error && <div className={cs(classes.errorMessage)}>{error}</div>}
    </div>
  );
};

QuestionInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired, // Allow JSX
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
};

export default QuestionInput;

